export interface Article {
  id: number;
  title: string;
  slug: string;
  summary: string;
  content: string;
  coverImage: string;
  categoryId: number;
  categorySlug: string;
  categoryName: string;
  tags: string[];
  publishDate: string;
  views: number;
  hotScore: number;
  author: string;
}

export const articles: Article[] = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，疑似新恋情曝光引热议',
    slug: 'dingliu-nanxing-shenye-mihui',
    summary: '近日有媒体拍到某顶流男星深夜与一名神秘女子在某高档小区密会，两人举止亲密，疑似新恋情曝光。该消息一出，迅速登上热搜榜第一，引发网友疯狂讨论。据知情人士透露，该女子为圈外人，两人已交往数月。',
    content: `<p>近日，有知名娱记在社交媒体上曝光了一组照片，照片中某顶流男星深夜独自驾车前往某高档小区，与一名神秘女子会面。两人在小区内并肩而行，期间还多次亲密互动，看起来关系非同一般。</p><p>据目击者称，该男星当晚戴着口罩和帽子，十分低调，但仍然被认出。他与该女子在小区内散步约半小时后一同进入某栋楼内，直至次日凌晨才独自离开。</p><p>消息一出，立刻在网络上引发轩然大波。该男星的粉丝群体反应激烈，有人表示祝福，也有人质疑照片的真实性。截至目前，该男星及其工作室尚未对此事作出任何回应。</p><p>业内人士分析，如果恋情属实，这将是该男星时隔三年后首次公开恋情。此前他曾与某女星传出绯闻，但双方均予以否认。</p><p>值得注意的是，与该男星会面的女子身份也引发了网友的好奇。有人通过照片中的细节推测，该女子可能是一名海归金融从业者，并非娱乐圈人士。这一猜测也让不少网友表示这是真正的门当户对。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20male%20celebrity%20walking%20with%20mysterious%20woman%20at%20night%20in%20luxury%20apartment%20complex%2C%20paparazzi%20style%20photography%2C%20dramatic%20lighting%2C%20urban%20night%20scene%2C%20blurry%20background%20with%20city%20lights%2C%20warm%20tones%2C%20candid%20moment&width=800&height=450&seq=article-01&orientation=landscape',
    categoryId: 2,
    categorySlug: 'mingxing-bagua',
    categoryName: '明星八卦',
    tags: ['顶流男星', '新恋情', '深夜密会', '热搜'],
    publishDate: '2026-08-05',
    views: 1258000,
    hotScore: 98,
    author: '吃瓜前线',
  },
  {
    id: 2,
    title: '爆款综艺录制现场突发意外，导演组紧急叫停引猜测',
    slug: 'baokuan-zongyi-yiwai-tingbo',
    summary: '某卫视王牌综艺节目在最新一期录制过程中突发意外状况，导演组紧急叫停录制。现场观众透露，疑似有嘉宾在游戏环节中受伤，目前具体情况仍在调查中。节目组暂未对此事发表正式声明。',
    content: `<p>据现场观众爆料，昨日某卫视王牌综艺节目在录制最新一期时突发意外。在某个高难度游戏环节中，一位嘉宾疑似不慎摔倒受伤，导演组当即决定暂停录制。</p><p>现场目击者描述，当时正在进行一个需要嘉宾在限定时间内完成体能挑战的环节，突然听到一声惊呼，随后工作人员迅速围了上去。医护人员也在第一时间赶到现场进行处理。</p><p>该节目是当下最受欢迎的综艺节目之一，每期都会邀请多位当红明星参与。此次录制阵容也十分强大，包括多位一线演员和流量艺人。</p><p>消息传开后，网友们纷纷猜测受伤嘉宾的身份。有人根据节目以往的录制规律推测，受伤的可能是一位平时较少参加运动类综艺的女嘉宾。不过也有知情人士表示，情况并不严重，该嘉宾经休息后已无大碍。</p><p>截至目前，节目组官方尚未对此事发布任何公告。该期节目原定于下周五播出，不知是否会因此次意外而延期。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20recording%20studio%20with%20crew%20and%20cameras%2C%20dramatic%20moment%20on%20set%2C%20stage%20lights%2C%20production%20environment%2C%20warm%20stage%20lighting%2C%20behind%20the%20scenes%20atmosphere&width=800&height=450&seq=article-02&orientation=landscape',
    categoryId: 6,
    categorySlug: 'yingshi-zongyi',
    categoryName: '影视综艺',
    tags: ['综艺录制', '突发意外', '嘉宾受伤', '节目停播'],
    publishDate: '2026-08-04',
    views: 987000,
    hotScore: 92,
    author: '综艺探员',
  },
  {
    id: 3,
    title: '知名网红偷税漏税被查，涉及金额高达数千万',
    slug: 'zhiming-wanghong-toushui-beicha',
    summary: '税务部门近日公布了一起网红偷税漏税案件，某拥有千万粉丝的知名网红因涉嫌偷逃税款被立案调查。据悉，该网红通过多种方式隐匿收入，涉案金额高达数千万元，目前已被要求补缴税款及滞纳金。',
    content: `<p>日前，国家税务总局在其官方网站上公布了一起网络主播偷税漏税案件。涉案网红在短视频平台拥有超过两千万粉丝，是行业内知名的头部主播。</p><p>根据通报，该网红在2023年至2025年期间，通过设立个人独资企业、虚构业务等方式，将个人直播收入转换为企业经营收入，以此逃避个人所得税的缴纳。此外，该网红还存在隐匿直播打赏收入、虚假申报等问题。</p><p>经税务部门调查核实，该网红共需补缴税款、滞纳金及罚款合计超过3800万元。目前，该网红已按要求全额补缴。</p><p>此消息一出，迅速在网络上引发热议。不少网友对该网红表示失望，称赚那么多钱还不愿意交税，太让人寒心了。也有业内人士表示，这已是今年以来第三起网红偷税漏税案件，有关部门对网络直播行业的税务监管正在不断收紧。</p><p>截至目前，该网红的所有社交账号已被平台暂时封禁，其所属的MCN机构也宣布与其解除合作关系。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20tax%20bureau%20document%20on%20desk%20with%20calculator%20and%20money%2C%20serious%20official%20atmosphere%2C%20financial%20investigation%20theme%2C%20clean%20office%20setting%2C%20professional%20lighting%2C%20neutral%20tones&width=800&height=450&seq=article-03&orientation=landscape',
    categoryId: 5,
    categorySlug: 'wanghong-dongtai',
    categoryName: '网红动态',
    tags: ['网红偷税', '税务稽查', '千万罚款', '账号封禁'],
    publishDate: '2026-08-04',
    views: 1560000,
    hotScore: 96,
    author: '财经观察员',
  },
  {
    id: 4,
    title: '某知名导演被曝片场耍大牌，多名演员发文暗讽',
    slug: 'zhiming-daoyan-shuadapai',
    summary: '近日，多位演员在社交平台上发文疑似暗讽某知名导演在片场行为不当。有工作人员透露，该导演不仅频繁迟到，还对演员出言不逊，导致剧组氛围紧张。事件持续发酵中。',
    content: `<p>近日，娱乐圈再次掀起一波导演耍大牌话题。多位曾与某知名导演合作过的演员近日在社交平台上发布了一些意味深长的动态，疑似集体吐槽该导演在片场的恶劣行为。</p><p>一位二线女演员在微博上发文称：尊重是相互的，不是你有名气就可以随意践踏别人的尊严。虽然没有点名道姓，但结合她最近的拍摄经历，网友们很快锁定了目标。</p><p>随后，又有几位演员陆续发布了类似的内容。一位男演员写道：一个好的导演应该用作品说话，而不是靠吼叫和贬低演员来显示自己的权威。这些动态迅速获得大量转发和评论。</p><p>据某剧组工作人员匿名透露，该导演在拍摄新片期间确实存在诸多问题：经常迟到两三个小时、在现场随意修改剧本、对演员和工作人员言语粗暴等。有次因为一个镜头不满意，他在现场骂了一个女演员将近半小时，那个女演员当场就哭了。</p><p>截至目前，该导演及其工作室尚未对此事作出回应。但其即将上映的新片口碑恐将受到此次事件的影响。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20film%20set%20with%20director%20chair%20and%20camera%20equipment%2C%20tense%20atmosphere%2C%20film%20production%20scene%2C%20dramatic%20lighting%2C%20movie%20set%20backdrop%2C%20professional%20cinema%20environment&width=800&height=450&seq=article-04&orientation=landscape',
    categoryId: 1,
    categorySlug: 'yule-chigua',
    categoryName: '娱乐吃瓜',
    tags: ['导演耍大牌', '片场风波', '演员暗讽', '剧组矛盾'],
    publishDate: '2026-08-03',
    views: 892000,
    hotScore: 88,
    author: '片场直击',
  },
  {
    id: 5,
    title: '热门古装剧男女主角疑似因戏生情，片场互动甜蜜',
    slug: 'guzhuangju-nannvzhu-yinxishengqing',
    summary: '正在热播的古装大剧男女主角被拍到在片场互动亲密，疑似因戏生情。两人在拍摄间隙多次被目击暧昧互动，更有工作人员爆料称两人在剧组已是公开的秘密。该剧热度因此事件再次飙升。',
    content: `<p>正在各大平台热播的古装大剧近日再次成为焦点。有媒体爆料称，该剧的男女主角在拍摄期间因戏生情，已经发展成了真实的情侣关系。</p><p>据剧组工作人员透露，两人在拍摄初期还保持着一定的距离，但随着拍摄的深入，两人之间的互动越来越亲密。他们在片场经常形影不离，休息时间也在一起吃饭聊天，剧组里的人都看得出来。</p><p>更有知情人士爆料，在杀青宴上，男主角曾在酒后向女主角表白，当时大家都惊呆了，但女主角好像并不意外，两人的关系应该早就开始了。</p><p>此消息一出，该剧的播放量再次迎来一波高峰，相关话题也迅速登上热搜。两人的粉丝群体对此反应不一，CP粉自然是欢呼雀跃，但也有部分唯粉表示不能接受。</p><p>截至目前，双方经纪公司均未对此事作出正面回应，仅表示艺人私生活不便过多干涉。但两人的社交账号最近频繁互动，似乎也在暗示着什么。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20set%20with%20two%20actors%20in%20traditional%20hanfu%20costumes%2C%20romantic%20atmosphere%2C%20ancient%20Chinese%20palace%20background%2C%20soft%20warm%20lighting%2C%20cinematic%20composition%2C%20elegant%20mood&width=800&height=450&seq=article-05&orientation=landscape',
    categoryId: 1,
    categorySlug: 'yule-chigua',
    categoryName: '娱乐吃瓜',
    tags: ['因戏生情', '古装剧', '男女主角', 'CP'],
    publishDate: '2026-08-03',
    views: 1130000,
    hotScore: 94,
    author: '追剧小能手',
  },
  {
    id: 6,
    title: '某知名企业家被曝婚内出轨，原配忍无可忍发长文控诉',
    slug: 'qiyejia-hunnei-chugui-kongsu',
    summary: '一位商界知名企业家的原配妻子在社交平台发布长文，控诉丈夫婚内出轨多年，并详细列举了诸多证据。该长文目前已获得超过百万转发，成为今日最热门的社会话题之一。',
    content: `<p>今日凌晨，一位自称是某知名企业家妻子的用户在社交平台上发布了一篇长达三千字的长文，控诉丈夫长达数年的婚内出轨行为。</p><p>该用户在文中详细描述了自己是如何发现丈夫出轨的，并附上了聊天记录截图、转账记录、酒店入住记录等多项证据。文中写道：我忍耐了太久，以为为了家庭和孩子可以继续假装不知道，但我的沉默只会换来更大的伤害。</p><p>据长文透露，该企业家与多名女性存在不正当关系，其中还包括其公司内部员工。文中还称，该企业家曾多次以出差为由与情人约会，甚至还将情人安排在了公司重要岗位上。</p><p>此文一经发布，迅速在网络上引发巨大反响。网友们纷纷对发文者表示同情和支持，同时也对该企业家的行为表示谴责。有网友扒出了该企业家的身份，发现其正是某知名科技公司的创始人兼CEO。</p><p>截至目前，该企业家及其公司尚未对此事作出回应。但受此事件影响，该公司股价在今日开盘后出现了明显下跌。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20business%20man%20in%20suit%20walking%20with%20woman%20in%20luxury%20hotel%20lobby%2C%20dramatic%20mood%2C%20indoor%20scene%20with%20chandeliers%2C%20warm%20golden%20lighting%2C%20high-end%20atmosphere%2C%20suspenseful%20composition&width=800&height=450&seq=article-06&orientation=landscape',
    categoryId: 3,
    categorySlug: 'shehui-redian',
    categoryName: '社会热点',
    tags: ['婚内出轨', '企业家', '原配控诉', '社会话题'],
    publishDate: '2026-08-02',
    views: 2340000,
    hotScore: 99,
    author: '社会观察员',
  },
  {
    id: 7,
    title: '某女星整容前后对比照流出，网友直呼认不出',
    slug: 'nvxing-zhengrong-duibi',
    summary: '一组某知名女星出道前后的对比照片在网上疯传，巨大的容貌变化让网友惊呼完全不是同一个人。该女星此前一直坚称自己从未整容，此次对比照的曝光让其陷入舆论漩涡。',
    content: `<p>近日，一组某知名女星出道前与现在的对比照片在各大社交平台广泛传播。照片中，该女星的面部轮廓、鼻型、下巴等部位出现了明显的变化，与早期的样貌判若两人。</p><p>这组照片据称来自该女星高中时期的同学，拍摄于大约十年前。照片中的她面部较为圆润，鼻梁扁平，与如今精致的面容形成了巨大的反差。</p><p>该女星此前在多个采访中坚称自己从未进行过整容手术，仅做过一些皮肤管理项目。她曾表示：我只是瘦了很多，加上化妆技术的提升，看起来和以前不一样是很正常的。</p><p>然而此次照片曝光后，多位整形医生也加入讨论。一位知名整形医生在社交平台上分析称：从照片对比来看，该女星至少进行过双眼皮、鼻综合、面部轮廓三项手术，这是非常明显的医疗美容结果。</p><p>目前该女星的社交账号评论区已经被网友攻陷，有人表示理解，也有人认为整容没什么，但一直否认就让人不舒服了。其工作室暂未对此事作出回应。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20female%20celebrity%20before%20and%20after%20comparison%20concept%2C%20split%20image%20aesthetic%2C%20beauty%20and%20cosmetic%20theme%2C%20studio%20lighting%20portrait%20style%2C%20soft%20glamour%20photography%2C%20neutral%20background&width=800&height=450&seq=article-07&orientation=landscape',
    categoryId: 2,
    categorySlug: 'mingxing-bagua',
    categoryName: '明星八卦',
    tags: ['女星整容', '对比照', '容貌变化', '整形争议'],
    publishDate: '2026-08-02',
    views: 1890000,
    hotScore: 91,
    author: '颜值评测师',
  },
  {
    id: 8,
    title: '某直播平台头部主播被指虚假宣传，消费者集体维权',
    slug: 'zhibo-zhubo-xujia-xuanchuan',
    summary: '某直播带货平台头部主播近期陷入虚假宣传风波。多名消费者反映在该主播直播间购买的商品与宣传严重不符，更有消费者使用产品后出现过敏等不良反应。目前已有消费者组织集体维权。',
    content: `<p>直播带货行业再起波澜。近日，某知名直播带货平台的头号主播被大量消费者指控虚假宣传。据不完全统计，已有超过500名消费者加入了维权群，要求该主播及品牌方退款并赔偿。</p><p>事件的起因是该主播在直播间大力推荐的一款护肤品。在直播中，该主播宣称该产品三天见效、纯天然成分、适合所有肤质，并现场展示了使用前后的惊人效果对比。然而消费者购买使用后却发现效果远不如宣传，更有部分消费者在使用后出现了严重的皮肤过敏现象。</p><p>一位维权消费者告诉记者：花了两千多买了她推荐的那套护肤品，结果用了没几天脸上就大面积泛红发痒，去医院检查说是接触性皮炎。联系客服根本没人理，这才和其他受害者一起组织了维权。</p><p>业内人士分析称，头部主播的带货能力极强，一场直播能创造数千万甚至上亿的销售额，但部分主播为了追求销量而不惜夸大产品效果，已经严重损害了消费者权益。</p><p>截至目前，该主播及所属平台尚未对此事作出正式回应，但其直播间已被暂时限制评论功能。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20live%20streaming%20sales%20studio%20with%20products%20on%20table%2C%20ring%20light%20setup%2C%20ecommerce%20livestream%20environment%2C%20colorful%20product%20display%2C%20modern%20streaming%20equipment%2C%20bright%20studio%20lighting&width=800&height=450&seq=article-08&orientation=landscape',
    categoryId: 5,
    categorySlug: 'wanghong-dongtai',
    categoryName: '网红动态',
    tags: ['虚假宣传', '直播带货', '消费者维权', '产品质量'],
    publishDate: '2026-08-01',
    views: 1100000,
    hotScore: 90,
    author: '消费维权站',
  },
  {
    id: 9,
    title: '独家：某选秀节目淘汰选手爆料暗箱操作内幕',
    slug: 'xuanxiu-anxiang-caozuo-neimu',
    summary: '一档热门选秀节目的淘汰选手近日在接受采访时大爆猛料，称节目存在严重的暗箱操作，选手排名早已内定，所谓的观众投票只是走过场。该爆料引发行业震动。',
    content: `<p>近日，一位刚刚被淘汰的选秀节目选手在个人社交平台上发布了一段长达十五分钟的视频，公开揭露了该节目的诸多内幕。</p><p>该选手在视频中表示，节目中的选手排名其实在录制前就已经基本确定，所谓的观众实时投票很大程度上是被操控的。节目组会在投票截止前根据他们想要的排名来调整票数，我们选手其实心里都清楚，但不能说。</p><p>此外，该选手还爆料称，节目组会对选手进行人设塑造，通过剪辑手法刻意制造矛盾和话题。有时候我们明明在正常聊天，被他们一剪就成了互撕。很多人设崩塌的选手其实非常冤枉。</p><p>更令人震惊的是，该选手还透露有赞助商直接干预选手去留的情况。有个选手唱跳都不行，但因为背后有金主赞助，一路被保送到了前二十。</p><p>此视频发布后，迅速在网络上引发轩然大波。节目组官方回应称该选手的言论纯属造谣，将保留追究法律责任的权利。但不少网友表示相信该选手的说法，并呼吁有关部门对选秀行业进行整顿。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20talent%20show%20stage%20with%20spotlights%20and%20empty%20audience%20seats%2C%20dramatic%20stage%20lighting%2C%20behind%20the%20scenes%20atmosphere%2C%20reality%20show%20production%2C%20dark%20moody%20composition%2C%20mysterious%20vibe&width=800&height=450&seq=article-09&orientation=landscape',
    categoryId: 4,
    categorySlug: 'zuixin-baoliao',
    categoryName: '最新爆料',
    tags: ['选秀内幕', '暗箱操作', '选手爆料', '排名造假'],
    publishDate: '2026-08-01',
    views: 1450000,
    hotScore: 95,
    author: '内幕调查组',
  },
  {
    id: 10,
    title: '明星夫妻被曝已秘密离婚，财产分割成焦点',
    slug: 'mingxing-fuqi-mimi-lihun',
    summary: '娱乐圈又一对明星夫妻被曝已秘密办理离婚手续。据悉两人早在半年前就已分居，一直在低调处理财产分割和孩子抚养权问题。多位圈内人士证实了这一消息。',
    content: `<p>据多位圈内知情人士透露，某知名明星夫妻已经在数月前秘密办理了离婚手续，但由于涉及巨额财产分割和孩子的抚养权等问题，双方一直在低调处理，未对外公开。</p><p>这对明星夫妻结婚已超过八年，曾是圈内公认的模范夫妻，经常在公开场合秀恩爱。但据知情人透露，两人的婚姻早在两年前就出现了裂痕。主要是聚少离多，加上双方事业发展方向不同，矛盾越积越深。</p><p>据悉，两人名下的共同财产估值超过五亿元，包括多套豪宅、豪车以及共同投资的公司股权。目前双方律师团队正在进行财产分割谈判，据传男方愿意在财产分配上做出较大让步，但希望在孩子的抚养权问题上争取更多权益。</p><p>消息传出后，网友纷纷感叹再也不相信爱情了。也有网友翻出两人近期在社交平台上的动态，发现确实已经很久没有互动，且双方最近发布的照片中都没有佩戴婚戒。</p><p>截至目前，双方经纪团队均以艺人私事不便回应为由拒绝正面评论。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20couple%20walking%20apart%20on%20red%20carpet%2C%20dramatic%20lighting%2C%20emotional%20distance%2C%20luxury%20event%20setting%2C%20cinematic%20photography%2C%20warm%20golden%20tones%20with%20melancholy%20mood&width=800&height=450&seq=article-10&orientation=landscape',
    categoryId: 2,
    categorySlug: 'mingxing-bagua',
    categoryName: '明星八卦',
    tags: ['明星离婚', '秘密离婚', '财产分割', '抚养权'],
    publishDate: '2026-07-31',
    views: 1670000,
    hotScore: 93,
    author: '婚姻观察家',
  },
  {
    id: 11,
    title: '重磅：某互联网大厂高管利用职权骚扰女员工被开除',
    slug: 'hulianwang-gaoguan-saorao',
    summary: '某知名互联网大厂内部邮件曝光，一位高级副总裁因利用职权对多名女员工进行骚扰被公司开除。该邮件在公司内部引发巨大反响，多位员工在匿名平台发声支持公司决定。',
    content: `<p>一份据称来自某互联网大厂内部的邮件近日在网络上流传。邮件显示，该公司一位高级副总裁因多次利用职权对女员工进行骚扰，经内部调查属实后已被公司开除。</p><p>邮件中详细列举了该高管的违规行为，包括：在深夜向女下属发送不当信息、以工作为由要求与女员工单独出差并安排在酒店房间开会、多次在工作场合对女员工进行肢体接触等。</p><p>据该公司员工透露，这次内部调查始于一个月前，当时有女员工通过公司匿名举报渠道反映了该高管的行为。公司这次的处理速度很快，从接到举报到做出决定，只用了不到三周的时间。</p><p>该邮件在公司内部发布后，获得了员工的广泛好评。多位员工在公司匿名论坛上表示支持公司的决定，这让我们看到了公司在处理职场骚扰问题上的态度和决心。</p><p>目前这起事件已经在整个互联网行业引发讨论，多个互联网公司的员工纷纷在社交平台上分享类似经历，呼吁全行业建立更完善的职场骚扰防治机制。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20tech%20office%20building%20exterior%20at%20night%2C%20corporate%20headquarters%2C%20glass%20architecture%2C%20urban%20landscape%2C%20professional%20environment%2C%20dramatic%20city%20night%20lighting%2C%20reflective%20surfaces&width=800&height=450&seq=article-11&orientation=landscape',
    categoryId: 3,
    categorySlug: 'shehui-redian',
    categoryName: '社会热点',
    tags: ['职场骚扰', '互联网大厂', '高管被开除', '女性权益'],
    publishDate: '2026-07-31',
    views: 2010000,
    hotScore: 97,
    author: '职场调查员',
  },
  {
    id: 12,
    title: '某知名歌手新歌涉嫌抄袭海外作品，原作者发声维权',
    slug: 'zhiming-geshou-chaoxi-weiquan',
    summary: '国内某知名歌手最新发布的主打歌被网友发现与一首海外热门歌曲旋律高度相似。原作者在社交媒体上发文表示震惊，并称将采取法律手段维权。目前该歌手的作品已在部分平台下架。',
    content: `<p>音乐圈再爆抄袭丑闻。国内某知名歌手于上周五发布的最新单曲被乐迷发现与一首去年在海外爆红的热门单曲在旋律、编曲上高度相似。</p><p>有热心网友制作了两首歌曲的对比视频，将两首歌的副歌部分并排播放，相似度之高让不少网友惊呼这简直一模一样。该对比视频在短时间内获得了数百万播放量。</p><p>随后，海外原唱作者在社交媒体上转发了该对比视频，并配文写道：This is shocking. My team is looking into this.（这太令人震惊了。我的团队正在调查此事。）据悉，原作者已委托律师与中方相关版权代理机构联系。</p><p>国内多位音乐人也对此事发表了看法。一位知名音乐制作人表示：国内音乐行业的版权意识这些年确实在提高，但抄袭事件仍时有发生。真正有才华的音乐人应该靠原创作品说话。</p><p>受此事件影响，涉事歌手的新歌已在多个音乐平台被暂时下架。其工作室发布声明称正在与相关方面沟通，对于是否存在抄袭问题将接受专业鉴定。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20music%20recording%20studio%20with%20microphone%20and%20mixing%20console%2C%20professional%20audio%20equipment%2C%20creative%20workspace%2C%20warm%20ambient%20studio%20lighting%2C%20modern%20music%20production%20environment%2C%20artistic%20atmosphere&width=800&height=450&seq=article-12&orientation=landscape',
    categoryId: 1,
    categorySlug: 'yule-chigua',
    categoryName: '娱乐吃瓜',
    tags: ['歌曲抄袭', '版权维权', '音乐下架', '原创争议'],
    publishDate: '2026-07-30',
    views: 920000,
    hotScore: 87,
    author: '音乐侦探',
  },
  {
    id: 13,
    title: '某地发生恶性事件引全网关注，警方通报已介入调查',
    slug: 'exing-shijian-jingfang-diaocha',
    summary: '近日某地发生的一起恶性事件在社交媒体上引发广泛关注。相关视频和图片在网络上大量传播，网友纷纷表达愤怒和关注。当地警方已发布通报，表示已成立专案组进行调查。',
    content: `<p>近日，一段在某地拍摄的视频在网络上大量传播，内容显示了一起引发公众强烈关注的恶性事件。该视频在各社交平台上的累计播放量已超过五千万次，相关话题持续占据热搜榜前列。</p><p>视频内容显示，在某公共场所发生了多人参与的冲突事件。围观群众拍摄的画面中可以看到现场一度非常混乱。有目击者描述称，事件造成了多人受伤，其中有人伤势严重。</p><p>事件发生后，当地警方迅速行动。据悉，多名涉案人员已被警方控制。当地公安局在官方微博上发布了警情通报，表示已对事件立案侦查，并成立了专门的调查组，将依法严惩违法犯罪行为。</p><p>该事件也引发了社会各界的广泛讨论。多位法律专家在接受采访时表示，此次事件暴露了某些公共安全管理中的薄弱环节，呼吁相关部门加强公共场所的安全防范措施。</p><p>截至目前，受伤人员均在医院接受治疗，暂无生命危险。案件的进一步调查仍在进行中。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20police%20cars%20with%20flashing%20lights%20at%20night%20in%20urban%20street%2C%20emergency%20response%20scene%2C%20city%20night%20atmosphere%2C%20dramatic%20lighting%2C%20public%20safety%20theme%2C%20professional%20news%20photography%20style&width=800&height=450&seq=article-13&orientation=landscape',
    categoryId: 3,
    categorySlug: 'shehui-redian',
    categoryName: '社会热点',
    tags: ['恶性事件', '警方通报', '全网关注', '公共安全'],
    publishDate: '2026-07-30',
    views: 3100000,
    hotScore: 100,
    author: '热点直击',
  },
  {
    id: 14,
    title: '某影视公司被曝拖欠演员工资，多位艺人集体讨薪',
    slug: 'yingshi-gongsi-tuoqian-gongzi',
    summary: '一家知名影视制作公司近日被爆出长期拖欠演员和工作人员工资。多位曾与该公司合作的演员在社交平台上发声讨薪，称已多次沟通无果，只能公开维权。',
    content: `<p>影视寒冬之下，又一家制作公司陷入财务危机。据多位演员和幕后工作人员反映，某知名影视制作公司已经拖欠了他们长达半年以上的薪酬。</p><p>一位曾在多部热播剧中出演重要角色的演员在微博上发文称：拍完戏到现在已经八个月了，尾款一直拖着不给。每次催款都说下个月，但这个下个月永远来不了。这条微博获得了大量同行的转发和声援。</p><p>随后，陆续有更多受害者站出来发声。一位编剧透露，该公司拖欠其稿费已超过一年，金额高达数十万元。他们用各种理由推脱，现在干脆连电话都不接了。</p><p>据悉，该公司此前出品过多部口碑不错的影视作品，在业界有一定的知名度。但近两年受影视行业整体调整的影响，公司经营出现了严重困难。</p><p>有律师表示，被拖欠薪酬的演员和工作人员可以通过法律途径维权，建议受害者联合起来共同起诉，以提高维权效率和成功率。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20film%20production%20company%20office%20with%20contracts%20and%20scripts%20on%20desk%2C%20tense%20business%20atmosphere%2C%20financial%20documents%2C%20professional%20office%20setting%2C%20worried%20mood%2C%20neutral%20office%20lighting&width=800&height=450&seq=article-14&orientation=landscape',
    categoryId: 6,
    categorySlug: 'yingshi-zongyi',
    categoryName: '影视综艺',
    tags: ['拖欠工资', '演员讨薪', '影视公司', '行业寒冬'],
    publishDate: '2026-07-29',
    views: 780000,
    hotScore: 84,
    author: '行业观察员',
  },
  {
    id: 15,
    title: '爆料：某顶流女星与经纪公司闹解约，涉及天价违约金',
    slug: 'dingliu-nvxing-jieyue-weiyuejin',
    summary: '据业内人士爆料，某顶流女星正在与其经纪公司协商解约事宜。据悉双方在分成比例和资源分配上存在严重分歧，如果解约成功，该女星可能需要支付高达数亿元的天价违约金。',
    content: `<p>娱乐圈再起合约风波。据多位消息人士透露，当前最炙手可热的某顶流女星正在秘密与其经纪公司协商解约事宜，双方的矛盾已经持续了相当长一段时间。</p><p>据知情人透露，该女星与经纪公司的合约还有三年多才到期，但双方在多个方面产生了严重分歧。首先是分成比例问题，该女星认为以自己如今的市场价值，现有的分成比例极不合理；其次是资源分配问题，公司近期将更多优质资源倾斜给了新签约的艺人。</p><p>她觉得自己在公司这些年为公司创造了巨大的价值，但现在公司却把最好的资源给了别人，这是她最不能接受的。一位与双方都有交往的业内人士表示。</p><p>如果单方面解约，该女星将面临巨额违约金。根据当初签订的合约条款以及她目前的商业价值估算，违约金可能高达三到五亿元。目前已有多个大型经纪公司对该女星表示了兴趣，愿意为其支付部分或全部违约金。</p><p>截至目前，该女星及其经纪公司均未对此事作出公开回应。但知情人士表示，双方的法律团队已经在进行接触，短期内可能会有结果。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20female%20celebrity%20in%20elegant%20dress%20looking%20away%20from%20camera%2C%20luxury%20setting%2C%20dramatic%20portrait%20photography%2C%20golden%20hour%20lighting%2C%20high-end%20fashion%20aesthetic%2C%20contemplative%20mood&width=800&height=450&seq=article-15&orientation=landscape',
    categoryId: 4,
    categorySlug: 'zuixin-baoliao',
    categoryName: '最新爆料',
    tags: ['顶流女星', '解约风波', '天价违约金', '经纪公司'],
    publishDate: '2026-07-29',
    views: 1320000,
    hotScore: 89,
    author: '内幕知情者',
  },
  {
    id: 16,
    title: '某热门网剧被指抄袭多部经典作品，编剧回应遭群嘲',
    slug: 'rewang-wangju-chaoxi-bianju',
    summary: '近期热播的一部网剧被观众发现剧情与多部经典作品高度雷同。面对质疑，该剧编剧发文回应称是致敬而非抄袭，遭到网友群嘲。原作者也纷纷发声表示不满。',
    content: `<p>正在热播的一部网剧近日陷入抄袭风波。有细心的观众发现，该剧的多处剧情桥段、人物设定甚至台词都与多部经典剧集和电影高度相似。</p><p>热心网友制作了详细的对比整理，列出了该剧与至少四部知名作品的相似之处，包括关键情节转折、人物关系设定以及多处经典台词。该对比帖文迅速在网络上传播，阅读量已超过千万。</p><p>面对越来越多的质疑声，该剧的编剧终于在社交平台上发文回应。在文中，编剧表示：好的作品是站在巨人肩膀上的，我的创作是对经典作品的致敬。每一个创作者都会受到前辈作品的影响，这是正常的创作规律。</p><p>然而这番回应并未平息争议，反而引发了更大的质疑。不少网友嘲讽称：把抄作业说成是致敬，这借口也太敷衍了。更有原作者直接在评论区留言表示：致敬和抄袭的区别在于是否尊重原创，如果你真的想致敬，请先获得授权。</p><p>截至目前，该剧的播出平台尚未对此事作出回应，剧集仍然正常播出中。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20web%20drama%20script%20on%20desk%20with%20coffee%20and%20laptop%2C%20creative%20writing%20workspace%2C%20modern%20office%20with%20warm%20lighting%2C%20storytelling%20concept%2C%20artistic%20atmosphere%2C%20cozy%20creative%20environment&width=800&height=450&seq=article-16&orientation=landscape',
    categoryId: 6,
    categorySlug: 'yingshi-zongyi',
    categoryName: '影视综艺',
    tags: ['网剧抄袭', '编剧回应', '经典作品', '原创争议'],
    publishDate: '2026-07-28',
    views: 860000,
    hotScore: 86,
    author: '剧评人老张',
  },
];

export function getArticleById(id: number): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.categorySlug === categorySlug);
}

export function getHotArticles(limit: number = 8): Article[] {
  return [...articles].sort((a, b) => b.hotScore - a.hotScore).slice(0, limit);
}

export function getLatestArticles(limit: number = 10): Article[] {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, limit);
}

export function getRelatedArticles(articleId: number, limit: number = 4): Article[] {
  const article = getArticleById(articleId);
  if (!article) return [];
  return articles
    .filter((a) => a.id !== articleId && a.categoryId === article.categoryId)
    .slice(0, limit);
}